import { makeStyles } from '@material-ui/core/styles'
import {
  getFilterMenuItemSelectedStyles,
  getFilterMenuLeadingStyles,
} from '@components/coaches-search/filter-menu-item.styles'

export const useStyles = makeStyles((theme) => ({
  filterToolbar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    justifyContent: 'center',
  },
  filterIconGroup: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
  },
  filterToolbarDivider: {
    alignSelf: 'center',
    height: 32,
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.25),
    backgroundColor: '#dfe3ea',
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  filterPillButton: {
    minHeight: 36,
    height: 36,
    padding: theme.spacing(0.375, 1.25),
    borderRadius: 999,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.2,
    color: '#00234B',
    backgroundColor: theme.palette.common.white,
    border: '1px solid #dfe3ea',
    boxShadow: 'none',
    textDecoration: 'none',
    cursor: 'pointer',
    '& .MuiButton-label': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(0.75),
      marginLeft: 0,
      color: 'inherit',
      '& svg': {
        width: 16,
        height: 16,
      },
    },
    '& .MuiButton-endIcon': {
      marginLeft: theme.spacing(0.25),
      marginRight: 0,
      color: 'inherit',
      '& svg': {
        width: 16,
        height: 16,
      },
    },
    '&:hover': {
      backgroundColor: theme.palette.blue.light25,
      borderColor: theme.palette.blue.main,
      color: theme.palette.blue.main,
      boxShadow: 'none',
      textDecoration: 'none',
    },
  },
  filterPillCaret: {
    flexShrink: 0,
    transition: theme.transitions.create('transform', { duration: theme.transitions.duration.shorter }),
  },
  filterPillCaretOpen: {
    transform: 'rotate(180deg)',
  },
  filterPillButtonActive: {
    color: '#3268A7',
    backgroundColor: '#ECF2F9',
    border: '1px solid #3268A7',
    '&:hover': {
      color: '#3268A7',
      backgroundColor: '#ECF2F9',
      borderColor: '#3268A7',
      textDecoration: 'none',
    },
  },
  savedCoachesToggleWrap: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  filterMenuPaper: {
    borderRadius: 12,
    backgroundColor: theme.palette.common.white,
    border: '1px solid rgba(15, 50, 84, 0.08)',
    boxShadow: '0 8px 24px rgba(15, 34, 52, 0.12)',
    minWidth: 220,
    marginTop: theme.spacing(0.75),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  filterMenuSectionTitle: {
    opacity: 1,
    minHeight: 32,
    paddingTop: theme.spacing(0.75),
    paddingBottom: theme.spacing(0.25),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    '& .MuiTypography-root': {
      color: '#7c8797',
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(11),
      letterSpacing: '0.08em',
      lineHeight: 1.2,
    },
  },
  filterMenuItem: {
    minHeight: 40,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    cursor: 'pointer',
    '& .MuiTypography-root': {
      color: theme.palette.text.primary,
      fontWeight: 500,
    },
  },
  filterMenuItemSelected: getFilterMenuItemSelectedStyles(theme),
  ...getFilterMenuLeadingStyles(theme),
  iconFilterCircle: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    boxSizing: 'border-box',
    width: 36,
    height: 36,
    minWidth: 36,
    maxWidth: 36,
    minHeight: 36,
    maxHeight: 36,
    padding: 0,
    borderRadius: '50%',
    textTransform: 'none',
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    border: '1px solid #dfe3ea',
    backgroundColor: theme.palette.common.white,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.common.white,
      borderColor: '#cfd6e0',
      boxShadow: 'none',
    },
    '&:active': {
      backgroundColor: theme.palette.common.white,
      borderColor: '#cfd6e0',
      boxShadow: 'none',
    },
    '&.Mui-disabled': {
      color: '#c7ccd3',
      backgroundColor: theme.palette.common.white,
      borderColor: '#dfe3ea',
    },
    '& .MuiButton-startIcon': {
      margin: 0,
      display: 'inline-flex',
      color: 'inherit',
      '& svg': {
        width: 16,
        height: 16,
      },
    },
  },
  iconFilterCircleActive: {
    color: '#3268A7 !important',
    border: '1px solid #3268A7',
    backgroundColor: '#ECF2F9',
    boxShadow: 'none',
    '&:hover': {
      borderColor: '#3268A7',
      backgroundColor: '#ECF2F9',
      boxShadow: 'none',
    },
    '&:active': {
      borderColor: '#3268A7',
      backgroundColor: '#ECF2F9',
      boxShadow: 'none',
    },
    '& .MuiButton-startIcon': {
      margin: 0,
      display: 'inline-flex',
      color: '#3268A7',
      '& svg': {
        width: 16,
        height: 16,
      },
    },
  },
}))
